import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, BadgeCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

import logo2 from "../../images/logos/2.png.bv_resized_desktop.png";
import logo4 from "../../images/logos/4.png.bv_resized_desktop.png";
import logo5 from "../../images/logos/5.png.bv_resized_desktop.png";
import logoAdhunik from "../../images/logos/ADHUNIK-YANTRA-UDYOG.png.bv_resized_desktop.png";
import logoBalwant from "../../images/logos/balwant-steel-v1.jpg.bv_resized_desktop.jpg";
import logoDNS from "../../images/logos/dns.png.bv_resized_desktop.png";
import logoIMR from "../../images/logos/IMR.jpg.bv_resized_desktop.jpg";
import logoMukesh from "../../images/logos/MUKESH-GROUP.png.bv_resized_desktop.png";
import logoNeotric from "../../images/logos/neotricgroup.jpeg.bv_resized_desktop.jpeg";
import logoRMC from "../../images/logos/rmc.jpg.bv_resized_desktop.jpg";
import logoSteelcraft from "../../images/logos/STEELCRAFT-NEW-LOGO.png.bv_resized_desktop.png";
import logoWisechamp from "../../images/logos/WISECHAMP.png.bv_resized_desktop.png";

const logos = [
  logo2,
  logo4,
  logo5,
  logoAdhunik,
  logoBalwant,
  logoDNS,
  logoIMR,
  logoMukesh,
  logoNeotric,
  logoRMC,
  logoSteelcraft,
  logoWisechamp,
];

const CompaniesMarquee = () => {
  const navigate = useNavigate();
  const reduceMotion = useReducedMotion();
  const leftRow = logos.slice(0, 6);
  const rightRow = logos.slice(6);

  return (
    <section id="companies" className="bg-gradient-to-b from-white to-amber-50/30 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: reduceMotion ? 0 : 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8 text-center"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-white px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.12em] text-amber-800">
            <BadgeCheck className="h-4 w-4 text-orange-500" />
            Trusted by growing businesses
          </div>
          <h2 className="mt-4 text-3xl font-black text-gray-900 sm:text-4xl">
            Teams Across Industries Already Use This Platform
          </h2>
        </motion.div>

        <div className="space-y-4 overflow-hidden rounded-3xl border border-amber-100 bg-white p-5 sm:p-7">
          <div className="group overflow-hidden">
            <div className="animate-scroll-left flex w-max gap-4 group-hover:[animation-play-state:paused]">
              {[...leftRow, ...leftRow].map((logo, idx) => (
                <div
                  key={`left-${idx}`}
                  className="flex h-16 w-44 items-center justify-center rounded-xl border border-amber-100 bg-white px-4"
                >
                  <img src={logo} alt="Client logo" className="max-h-10 w-auto object-contain" />
                </div>
              ))}
            </div>
          </div>

          <div className="group overflow-hidden">
            <div className="animate-scroll-right flex w-max gap-4 group-hover:[animation-play-state:paused]">
              {[...rightRow, ...rightRow].map((logo, idx) => (
                <div
                  key={`right-${idx}`}
                  className="flex h-16 w-44 items-center justify-center rounded-xl border border-amber-100 bg-white px-4"
                >
                  <img src={logo} alt="Client logo" className="max-h-10 w-auto object-contain" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-amber-200 bg-gradient-to-r from-amber-100/60 to-orange-100/40 p-5 text-center sm:flex-row sm:text-left">
          <p className="text-sm font-medium text-gray-700 sm:text-base">
            Join the next batch of teams scaling their WhatsApp communication.
          </p>
          <button
            type="button"
            onClick={() => navigate("/auth")}
            className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-amber-500 to-orange-500 px-5 py-2.5 text-sm font-semibold text-white"
          >
            Get Started
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default CompaniesMarquee;